import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/App/Home'
    },
    // 机构选择
    {
      path: '/Organization',
      name: 'Organization',
      component: () =>
        import('@/views/Organization')
    },
    // 院区选择
    {
      path: '/hospitalDistrict',
      name: 'HospitalDistrict',
      component: () =>
        import('@/views/hospitalDistrict')
    },
    //首页
    {
      path: '/App',
      name: 'App',
      component: () =>
        import('@/views/App'),
      children: [{
          path: 'Home',
          name: 'Home',
          component: () =>
            import('@/views/App/Home')
        },
        {
          path: 'My',
          name: 'My',
          component: () =>
            import('@/views/App/My')
        }
      ]
    },
    // 手机验证
    {
      path: '/phoneVerification',
      name: 'PhoneVerification',
      component: () =>
        import('@/views/App/My/phoneVerification')
    },
    // 健康卡管理
    {
      path: '/healthCard',
      name: 'HealthCard',
      component: () =>
        import('@/views/App/My/healthCard')
    },
    //新增健康卡
    {
      path: '/createHealthCard',
      name: 'CreateHealthCard',
      component: () =>
        import('@/views/App/My/createHealthCard')
    },
    // 挂号记录
    {
      path: '/registrationRecord',
      name: 'RegistrationRecord',
      component: () =>
        import('@/views/App/My/registrationRecord')
    },
    // 挂号详情
    {
      path: '/registrationDetail/:detail',
      name: 'RegistrationDetail',
      component: () =>
        import('@/views/App/My/registrationDetail')
    },
    // 缴费记录
    {
      path: '/paymentRecord',
      name: 'PaymentRecord',
      component: () =>
        import('@/views/App/My/paymentRecord')
    },
    // 缴费记录详情
    {
      path: '/paymentRecordDetail',
      name: 'PaymentRecordDetail',
      component: () =>
        import('@/views/App/My/paymentRecordDetail')
    },
    // 满意度调查
    {
      path: '/satisfactionSurvey',
      name: 'SatisfactionSurvey',
      component: () =>
        import('@/views/App/My/satisfactionSurvey')
    },
    // 消息中心
    {
      path: '/messageCenter',
      name: 'MessageCenter',
      component: () =>
        import('@/views/App/My/messageCenter')
    },
    // 消息中心详情
    {
      path: '/messageCenterDetail/:id',
      name: 'MessageCenterDetail',
      component: () =>
        import('@/views/App/My/messageCenterDetail')
    },
    // 门诊挂号
    {
      path: '/outPatientRegistration',
      name: 'OutPatientRegistration',
      component: () =>
        import('@/views/MedicalServices/Register/outPatientRegistration')
    },
    // 科室挂号医生列表
    {
      path: '/departmentDoctorList/:departmentId',
      name: 'DepartmentDoctorList',
      component: () =>
        import('@/views/MedicalServices/Register/departmentDoctorList')
    },
    // 医生预约挂号详情
    {
      path: '/doctorRegisterDetail/',
      name: 'DoctorRegisterDetail',
      component: () =>
        import('@/views/MedicalServices/Register/doctorRegisterDetail')
    },
    // 确认挂号
    {
      path: '/registerConfirm',
      name: 'RegisterConfirm',
      component: () =>
        import('@/views/MedicalServices/Register/registerConfirm')
    },
    // 支付方式
    {
      path: '/payMethods',
      name: 'PayMethods',
      component: () =>
        import('@/views/MedicalServices/Pay/payMethods')
    },
    // 支付成功
    {
      path: '/paySuccess/:BillId',
      name: 'PaySuccess',
      component: () =>
        import('@/views/MedicalServices/Pay/paySuccess')
    },
    // 支付失败
    {
      path: '/payFailed',
      name: 'PayFailed',
      component: () =>
        import('@/views/MedicalServices/Pay/payFailed')
    },
    // 支付取消
    {
      path: '/payCancel',
      name: 'PayCancel',
      component: () =>
        import('@/views/MedicalServices/Pay/payCancel')
    },
    // 支付中...
    {
      path: '/payDuring/:BillId',
      name: 'PayDuring',
      component: () =>
        import('@/views/MedicalServices/Pay/payDuring')
    },
    // 医院介绍
    {
      path: '/HospitalIntroduce',
      name: 'HospitalIntroduce',
      component: () =>
        import('@/views/MedicalServices/HospitalIntroduce')
    },
    // 科室介绍详情
    {
      path: '/departmentDetail/:id/:name',
      name: 'DepartmentDetail',
      component: () =>
        import('@/views/MedicalServices/HospitalIntroduce/departmentDetail')
    },
    // 专家介绍详情
    {
      path: '/expertDetail/:id',
      name: 'ExpertDetail',
      component: () =>
        import('@/views/MedicalServices/HospitalIntroduce/expertDetail')
    },
    // 门诊缴费
    {
      path: '/outpatientPayment',
      name: 'OutpatientPayment',
      component: () =>
        import('@/views/MedicalServices/outpatientPayment/')
    },
    // 住院预缴
    {
      path: '/prepayInHospital',
      name: 'PrepayInHospital',
      component: () =>
        import('@/views/MedicalServices/prepayInHospital/')
    },
    // 报告查询
    {
      path: '/myReport',
      name: 'MyReport',
      component: () =>
        import('@/views/MedicalServices/myReport/')
    },
    // 检查报告
    {
      path: '/inspectionReport',
      name: 'InspectionReport',
      component: () =>
        import('@/views/MedicalServices/myReport/inspectionReport')
    },
    // 检查报告详情
    {
      path: '/inspectionReportDetail',
      name: 'InspectionReportDetail',
      component: () =>
        import('@/views/MedicalServices/myReport/inspectionReportDetail')
    },
    // 检验报告
    {
      path: '/SurveyReport',
      name: 'surveyReport',
      component: () =>
        import('@/views/MedicalServices/myReport/SurveyReport')
    },
    // 检验报告详情
    {
      path: '/surveyReportDetail',
      name: 'SurveyReportDetail',
      component: () =>
        import('@/views/MedicalServices/myReport/surveyReportDetail')
    },
    // 候诊查询
    {
      path: '/waitQuery',
      name: 'WaitQuery',
      component: () =>
        import('@/views/MedicalServices/waitQuery')
    },
    // 住院查询
    {
      path: '/inHospitalQuery',
      name: 'InHospitalQuery',
      component: () =>
        import('@/views/MedicalServices/inHospitalQuery')
    },
    //住院预缴查询
    {
      path: '/inHospitalPay',
      name: 'InHospitalPay',
      component: () =>
        import('@/views/MedicalServices/InHospitalQuery/inHospitalPay')
    },
    //住院费用查询
    {
      path: '/queryInHospitalCost',
      name: 'QueryInHospitalCost',
      component: () =>
        import('@/views/MedicalServices/InHospitalQuery/queryInHospitalCost')
    },
    //基本信息查询
    {
      path: '/queryBasicInformation',
      name: 'QueryBasicInformation',
      component: () =>
        import('@/views/MedicalServices/InHospitalQuery/queryBasicInformation')
    },
    //电子健康卡
    {
      path: '/weChatCode',
      name: 'WeChatCode',
      component: () =>
        import('@/views/MedicalServices/WeChatCode')
    },
    // 门诊查询
    {
      path: '/outpatientQuery',
      name: 'OutpatientQuery',
      component: () =>
        import('@/views/MedicalServices/OutpatientQuery/index')
    },
    {
      path: '/outpatientDetails/:item',
      name: 'OutpatientDetails',
      component: () =>
        import('@/views/MedicalServices/OutpatientQuery/details')
    },
    // 就诊指南
    {
      path: '/clinicGuide',
      name: 'ClinicGuide',
      component: () =>
        import('@/views/MedicalServices/ClinicGuide/index')
    },
    {
      path: '/clinicGuideDetails/:id',
      name: 'ClinicGuideDetails',
      component: () =>
        import('@/views/MedicalServices/ClinicGuide/details')
    },
    // 医院公示
    {
      path: '/hospitalPublicity',
      name: 'HospitalPublicity',
      component: () =>
        import('@/views/MedicalServices/HospitalPublicity/index')
    },
    // 药品价格公示
    {
      path: '/drugPricePublicity',
      name: 'DrugPricePublicity',
      component: () =>
        import('@/views/MedicalServices/HospitalPublicity/drugPricePublicity')
    },
    // 质量项目价格公示
    {
      path: '/projectPricePublicity',
      name: 'ProjectPricePublicity',
      component: () =>
        import('@/views/MedicalServices/HospitalPublicity/projectPricePublicity')
    },
    // 床位查询
    {
      path: '/bedsQuery',
      name: 'BedsQuery',
      component: () =>
        import('@/views/MedicalServices/HospitalPublicity/bedsQuery')
    },
    // 添加就诊人
    {
      path: '/addPatient',
      name: 'AddPatient',
      component: () =>
        import('@/views/MedicalServices/Patients/addPatient')
    },
    // 身份核对
    {
      path: '/idCheck',
      name: 'IdCheck',
      component: () =>
        import('@/views/MedicalServices/Patients/idCheck')
    },
    // 添加就诊人成功
    {
      path: '/addPatientSuccess',
      name: 'AddPatientSuccess',
      component: () =>
        import('@/views/MedicalServices/Patients/addPatientSuccess')
    },
    {
      path:'/onlineConsultant',
      name:"OnlineConsultant",
      component:()=>import('@/views/MedicalServices/OnlineConsultant/index')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js